export class WholesalerDetail {
    constructor({
                    CustNo = null,
                    Email = null,
                    Id = null,
                    Bcc = null,
                    OutputFileName = null,
                } = {}) {
        this.CustNo = CustNo;
        this.Email = Email;
        this.Id = Id;
        this.Bcc = Bcc;
        this.OutputFileName = OutputFileName;
    }
}
export function createWholesalerDetail(data) {
    return Object.freeze(new WholesalerDetail(data));
}
